// extracted by mini-css-extract-plugin
export default {"sectionContainer":"SuHAuNFO","cardStyleWrapper":"FDfrxD4V","items":"tsVyCdcc","text":"Gr_v7JZ7","itemWrapper":"UgwkOAEN"};